import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { DashboardCard } from "@/shared/ui/DashboardCard";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { categorySales } from "../data";

export function SalesByCategory() {
  const { t } = useTranslation();

  return (
    <DashboardCard title={t.ecommerce.salesByCategory}>
      <ResponsiveContainer width="100%" height={180}>
        <PieChart>
          <Pie data={categorySales} cx="50%" cy="50%" innerRadius={50} outerRadius={75} dataKey="value" stroke="none" paddingAngle={3}>
            {categorySales.map((entry) => (
              <Cell key={entry.name} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="mt-2 grid grid-cols-2 gap-2">
        {categorySales.map((cat) => (
          <div key={cat.name} className="flex items-center gap-2">
            <div className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: cat.color }} />
            <span className="text-xs text-muted-foreground">
              {t.common.categories[cat.name]} ({cat.value}%)
            </span>
          </div>
        ))}
      </div>
    </DashboardCard>
  );
}
